export default __webpack_public_path__ + "static/media/icon-pencil.0516651e.svg";